import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/bffa825a-7d77-4508-b67f-0dfae5ce2e67";
export const REGISTER_URL = "https://a.ntrk2.com/6fe20945-2faa-4345-9df2-a59c3c8de823";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://luxwinph.kzw2a.com/download?openExternalBrowser=1&id=yb44nhit4a1of6w";

export * from "./codes";
export * from "./context";
